import { I18N_FORMAT_MAP } from '@rover/kibble/styles';

import generateExternalFormatMap from './generateExternalFormatMap';
import generateFormatMapForLang from './generateFormatMap';
import getLocalizedFormatContextless from './getLocalizedFormatContextless';

const getExternalFormatMap = (language: string): typeof I18N_FORMAT_MAP['en-us'] =>
  generateExternalFormatMap(getLocalizedFormatContextless, language);

export const getDateTimeFormatMapForLang = (language: string): typeof I18N_FORMAT_MAP['en-us'] =>
  generateFormatMapForLang(getLocalizedFormatContextless, language);

export {
  getDateTimeFormatMapForLang as default,
  getLocalizedFormatContextless as getLocalizedFormat,
  getExternalFormatMap,
  I18N_FORMAT_MAP,
};



// WEBPACK FOOTER //
// ../shared/js/constants/i18n/datetime/datetimeContextless.ts